import React, { useState } from 'react';
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

import { getCurrentLanguageTexts } from '../../../../constants/seasonPassPersonalInfoLangs';
import { SelectedTickets } from '../../../OpenSell/SelectedTickets';
import { SeasonPassFieldLabel } from '../../SeasonPassFieldLabel';
import { MembershipToSeasonPassTicket, NfcToTicket } from '../../../../helpers/ticketHelper.ts';

const MySwal = withReactContent(Swal);

export const BuyAllSeasonPassesModal = ({
    membershipCards,
    event,
    selectedTicketTemplates,
    onConfirmBuySeasonPass,
    availablePoints,
    title
}) => {

    const [companyName, setCompanyName] = useState(membershipCards[0].customerName);
    const [companyVatNumber, setCompanyVat] = useState('');
    const [companyCity, setCompanyCity] = useState('');
    const [companyAddress, setCompanyAddress] = useState('');

    const txt = getCurrentLanguageTexts();;
    const nfcCardTicket = event.ticketTemplates.find(t => t.ticketTemplateId == process.env.REACT_APP_NEW_SEASON_NFC_CARD_TICKET_TEMPLATE_ID);
    membershipCards = membershipCards.filter(c => !!c.seat)
    const seatDiscount = membershipCards.map(c => {
        return {
            seat: `${c.area}-${c.side}-${c.row}-${c.seat}`,
            discount: c.holdedDiscount
        }
    });

    // const templates = selectedTicketTemplates.map(t => {
    //     const discount = seatDiscount.filter(i => t.possibleSeats.includes(i.seat)).reduce((a, i) => a + i.discount, 0) / t.possibleSeats.length;

    //     return {
    //         name: `${t.possibleSeats.length} x ${t.name}`,
    //         price: t.price - discount,
    //         count: t.possibleSeats.length
    //     }d
    // });

    // templates.push({
    //     name: `${membershipCards.length} x ${nfcCardTicket.name}`,
    //     price: nfcCardTicket.price,
    //     count: membershipCards.length
    // })

    const tickets = membershipCards.flatMap(t => {
        const ticketTemplate = selectedTicketTemplates.find(tt => tt.possibleSeats.includes(t.area + (!!t.side ? `-${t.side}` : '') + `-${t.row}-${t.seat}`));

        if(!ticketTemplate)
        {
            return [];
        }
        else
        {
            const ticket = MembershipToSeasonPassTicket(t, ticketTemplate);
            
            ticket.fixedDiscount += t.holdedDiscount;

            return [ticket, NfcToTicket(t, nfcCardTicket)];
        }
    })

    let totalPrice = tickets.reduce((a, i) => a + i.getPrice(), 0);

    let pointsToDiscount = (totalPrice / 2).toFixed(0);

    if (pointsToDiscount > availablePoints) {
        pointsToDiscount = availablePoints;
    }

    totalPrice -= pointsToDiscount;

    const confirmHandler = () => {
        const seats = membershipCards.flatMap(membershipCard => {
            const ticketTemplate = selectedTicketTemplates.find(t => t.possibleSeats.includes(getLabel(membershipCard)))

            return [{
                ticketName: ticketTemplate.name,
                area: membershipCard.area,
                side: membershipCard.side,
                row: membershipCard.row,
                seat: membershipCard.seat,
                ticketTemplateId: ticketTemplate.ticketTemplateId,
                amount: (ticketTemplate.price - membershipCard.holdedDiscount).toFixed(2),
            }, {
                ticketName: nfcCardTicket.name,
                area: membershipCard.area,
                side: membershipCard.side,
                row: membershipCard.row,
                seat: membershipCard.seat,
                ticketTemplateId: nfcCardTicket.ticketTemplateId,
                amount: (nfcCardTicket.price).toFixed(2),
            }]
        });

        MySwal.close();
        onConfirmBuySeasonPass(seats, companyName, totalPrice, pointsToDiscount, {
            companyName,
            companyCity,
            companyAddress,
            companyVatNumber: companyVatNumber
        });
    };

    return <>
        <section className="fill-company-data-modal">
            <h2 className="first-title">{title}</h2>

            <p style={{ color: '#ababab', marginBottom: '24px' }} className='swal2-label'>{txt.BuyAllSeasonPassesModalTxt['modalDescription']}</p>

            <SeasonPassFieldLabel
                label={txt.BuyAllSeasonPassesModalTxt['companyNameLabel']}
                isRequired={!companyName}
                className="fill-company-data-modal__fields-label"
                shouldWrapInLabel={false}
            >
                <input value={companyName}
                    placeholder={txt.BuyAllSeasonPassesModalTxt['companyNamePlaceholder']}
                    className="modal-input"
                    onChange={e => setCompanyName(e.target.value)} />
            </SeasonPassFieldLabel>

            <SeasonPassFieldLabel
                label={txt.dataFormTxt.city}
                isRequired={!companyCity}
                className="fill-company-data-modal__fields-label"
                shouldWrapInLabel={false}
            >
                <input value={companyCity}
                    placeholder={txt.BuyAllSeasonPassesModalTxt['companyCityPlaceholder']}
                    className="modal-input"
                    onChange={e => setCompanyCity(e.target.value)} />
            </SeasonPassFieldLabel>

            <SeasonPassFieldLabel
                label={txt.BuyAllSeasonPassesModalTxt['companyAddressLabel']}
                isRequired={!companyAddress}
                className="fill-company-data-modal__fields-label"
                shouldWrapInLabel={false}
            >
                <input value={companyAddress}
                    placeholder={txt.BuyAllSeasonPassesModalTxt['companyAddressPlaceholder']}
                    className="modal-input"
                    onChange={e => setCompanyAddress(e.target.value)} />
            </SeasonPassFieldLabel>

            <SeasonPassFieldLabel
                label={txt.BuyAllSeasonPassesModalTxt['companyVatLabel']}
                isRequired={!companyVatNumber}
                className="fill-company-data-modal__fields-label"
                shouldWrapInLabel={false}
            >
                <input value={companyVatNumber}
                    placeholder={txt.BuyAllSeasonPassesModalTxt['companyVatPlaceholder']}
                    className="modal-input"
                    onChange={e => setCompanyVat(e.target.value)} />
            </SeasonPassFieldLabel>

            <SelectedTickets
                hasSeats={false}
                mixedTickets={false}
                administrativeFee={0} // disabled for invoices
                tickets={tickets}
                currency={'RSD'}
                total={totalPrice}
                allowEnterCouponCode={false}
                autoHeight={true}
                pointsForDiscount={pointsToDiscount}
                isTermsCheckbox={false}
                showShorted={true}
            />

            <section className='swal2-actions'>

                <button className="swal2-cancel swal2-styled"
                    onClick={() => MySwal.close()}>
                    {txt.generalTxt['cancel']}
                </button>

                <button disabled={(!companyName || !companyVatNumber || !companyCity || !companyAddress)} className="swal2-confirm swal2-styled"
                    onClick={confirmHandler}>
                    {txt.BuyAllSeasonPassesModalTxt['createInvoiceButton']}
                </button>

            </section>

        </section>
    </>
}

function getLabel(ticket) {
    if (!ticket.seat) {
        return '';
    }

    return ticket.area + (!!ticket.side ? `-${ticket.side}` : '') + `-${ticket.row}-${ticket.seat}`
}